import { LessonCard } from "./LessonCard";
import { rangeDays, addDays, fmtDayHeader, todayIso, closureFor } from "./calendarUtils";

export const WeekView = ({ from, lessons, colors, overlaps, closures, onOpen }) => {
  const today = todayIso();
  return (
    <div data-testid="cal-week" className="space-y-3 lg:space-y-0 lg:grid lg:grid-cols-7 lg:gap-2">
      {rangeDays(from, addDays(from, 6)).map((d) => {
        const items = lessons.filter((x) => x.date === d);
        const isToday = d === today;
        const cl = closureFor(d, closures);
        return (
          <section key={d} data-testid={`cal-week-day-${d}`} className={`rounded-xl border p-3 lg:p-2 lg:min-h-[180px] ${isToday ? "border-primary bg-primary/5" : "border-border bg-card"}`}>
            <h4 className={`text-lg lg:text-base font-semibold capitalize leading-tight ${isToday ? "text-primary" : "text-foreground"}`}>
              {fmtDayHeader(d)}{isToday && <span className="ml-2 text-xs font-medium normal-case rounded-full bg-primary text-primary-foreground px-2 py-0.5 align-middle" data-testid="cal-week-today">Oggi</span>}
            </h4>
            {cl && <p className="text-xs text-amber-800 mt-1" data-testid={`cal-week-closure-${d}`}>Scuola chiusa{cl.description ? ` · ${cl.description}` : ""}</p>}
            <div className="mt-2 space-y-2">
              {items.length === 0 ? <p className="text-sm text-muted-foreground/80">Nessuna lezione</p>
                : items.map((x) => <LessonCard key={x.id} x={x} color={colors[x.course]} overlap={overlaps.has(x.id)} onOpen={onOpen} showDate={false} />)}
            </div>
          </section>
        );
      })}
    </div>
  );
};
